// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconPostCard: React.FC<{}> = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="204"
            height="180"
            viewBox="0 0 204 180"
        >
            <defs>
                <pattern id="b" width="100%" height="100%" x="0%" patternUnits="objectBoundingBox">
                    <use xlinkHref="#a" transform="scale(1.66667)" />
                </pattern>
                <image
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAAs0lEQVRoBe2YQQrDMAwE4/7J/3+AH9XS4x7FkG0Dk5vAkuIZC4zX3vt9Db5zzhosv+6u/5r8zD+udQO/tqIBDUACHiEIEKdrACOEBR5vYHSv+cK6+24zrf94A24AziBO1wBGCAtoAALE6RrACGEBDUCAOH1N7x6+C2HmWcAZSB79SAN95tlRA8mjH2mgzzw7aiB59CPfhfrMs6MzkDz6kQb6zLOjBpJHP9JAn3l21EDy6EcfG0kbmWsMNT0AAAAASUVORK5CYII="
                    id="a"
                    width="48"
                    height="48"
                />
            </defs>
            <g fill="none">
                <text fill="#3B3B3B" fontFamily="Adelle-Regular, Adelle" fontSize="14">
                    <tspan x="0" y="150">
                        {"{Example copy goes here & is"}{" "}
                    </tspan>
                    <tspan x="0" y="172">
                        {"authored in the CMS}"}{" "}
                    </tspan>
                </text>
                <text fill="#0C0908" fontFamily="TVNordEF-BlackCon" fontSize="28">
                    <tspan x="0" y="117">
                        H3 : Title
                    </tspan>
                </text>
                <rect width="80" height="80" fill="url(#b)" fillRule="evenodd" />
            </g>
        </svg>
    );
};

export default React.memo(IconPostCard);
